import {
  ApiResponse,
  ChangeUserParams,
  CHAT_STATUS,
  ChatDto,
  ChatDtoDetail,
  ChatMemberDto,
  ChatMessageDto,
  CommonParams,
  MessageMasterDataDto,
  NewChatParams,
  UpdateChatParams,
} from "@/types";
import { filterParams } from "@/utils/filterParams";
import { jsonToFormData } from "@/utils/jsonToFormData";
import api from "./api";

export const ChatService = {
  async createChat(data: NewChatParams) {
    // Implementation here
    const fd = jsonToFormData(data);
    const res = await api.post<ApiResponse<ChatDto>>("/company-chat", fd, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return res.data;
  },
  async getChats(
    params?: CommonParams<{ status?: string; pic?: number; title?: string }>
  ) {
    // Implementation here
    const res = await api.get<ApiResponse<ChatDto[]>>("/company-chat", {
      params: {
        limit: 24,
        ...filterParams(params || {}),
      },
    });
    return res.data;
  },
  async getChatById(id: number) {
    // Implementation here
    const res = await api.get<ApiResponse<ChatDtoDetail>>(`/chat/${id}`);
    return res.data;
  },
  async updateChat(id: number, data: UpdateChatParams) {
    const fd = jsonToFormData(data);
    // Implementation here
    const res = await api.patch<ApiResponse<ChatDto>>(
      `/company-chat/${id}`,
      fd,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return res.data;
  },
  async deleteChat(id: number) {
    // Implementation here
    const res = await api.delete(`/chat/${id}`);
    return res.data;
  },
  async getChatMessages(
    chatId: number,
    params?: CommonParams<{
      lastMessageId?: number;
    }>
  ) {
    // Implementation here
    const res = await api.get<ApiResponse<ChatMessageDto[]>>(
      `/chat/chat-message/${chatId}`,
      {
        params: filterParams(params || {}),
      }
    );
    return res.data;
  },
  async getMasterData() {
    // get default message templates
    const res = await api.get<ApiResponse<MessageMasterDataDto[]>>(
      `/chat/message/master-data`
    );
    return res.data;
  },
  async getListChatMembers(chatId: number, params?: CommonParams<{}>) {
    // Implementation here
    const res = await api.get<ApiResponse<ChatMemberDto[]>>(
      `/chat/list-add-member/${chatId}`,
      {
        params: filterParams(params || {}),
      }
    );
    return res.data;
  },
  async changeStatus(id: number, status: CHAT_STATUS) {
    // Implementation here
    const res = await api.patch(`/chat/change-status/${id}`, { status });
    return res.data;
  },
  async getViewers(chatId: number, params?: CommonParams<{}>) {
    const res = await api.get<
      ApiResponse<{ user_email: string; user_id: number; user_name: string }[]>
    >(`/company-chat/viewers/${chatId}`, {
      params: {
        limit: 24,
        page: 1,
        ...filterParams(params || {}),
      },
    });
    return res.data;
  },
  async changeUser(chatId: number, params: ChangeUserParams) {
    const res = await api.patch<ApiResponse<void>>(
      `/company-chat/${chatId}/change-user`,
      params
    );
    return res.data;
  },
  async addMember(chatId: number, user_ids: number[]) {
    // Implementation here
    const res = await api.post(`/chat/add-member/${chatId}`, { user_ids });
    return res.data;
  },
};
